const EPG_BASE = '/services/epg/v1';
export const EPG_LINEUP_SERVICE = `${EPG_BASE}/lineup`;
